export default __webpack_public_path__ + "static/media/productDesign.a873fe8b.svg";